var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5426 13.0346C16.4038 13.0346 15.2884 12.8567 14.2312 12.5079C13.7153 12.3301 13.1293 12.4671 12.7902 12.813L10.6944 14.3959C8.28951 13.1123 6.7504 11.5742 5.48434 9.18679L7.02441 7.14047C7.4121 6.75278 7.55107 6.18531 7.38491 5.65383C7.03315 4.58986 6.85438 3.47342 6.85438 2.33658C6.85438 1.533 6.20047 0.879089 5.39689 0.879089H1.99607C1.19249 0.879089 0.538574 1.533 0.538574 2.33658C0.538574 11.7121 8.16708 19.3406 17.5426 19.3406C18.3462 19.3406 19.0001 18.6867 19.0001 17.8831V14.4921C19.0001 13.6885 18.3462 13.0346 17.5426 13.0346Z",
    fill: "#FD3845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCall);
export default __webpack_public_path__ + "static/media/stop_call.4c5293d8df08b9fc83aae3c9edf40430.svg";
export { ForwardRef as ReactComponent };